export const PoemCountYourBlessings = () => {
    return (
        <div id="021" className="">
            <p>there's no place close by when you can truly take in</p>
            <p>the sheer size of the world</p>
            <p>besides the parking lot of the nearest shopping center,</p>
            <p>in the middle of it, surrounded by carefully</p>
            <p>equidistantly placed decorative trees</p>
            <p>you can take in the night sky in its</p>
            <p>abridged but still reasonably sized glory,</p>
            <p>itself surrounded by</p>
            <p>egg yolk yellows gushing out of street lights.</p>
            <p>you take what you can,</p>
            <p>you count your blessings.</p>
            <br />
            <p>50 feet away from my apartment block</p>
            <p>there's a place where if you're alone at the right time</p>
            <p>the sky opens up like the folds of an eye</p>
            <p>with the moon as its pupil.</p>
            <p>50 feet away from my apartment block there's a place</p>
            <p>where it looks like you can stare God in the eye</p>
            <p>and when it rains, the water dripping</p>
            <p>sounds like somebody's whispers.</p>
            <br />
            <p>you count your blessings</p>
            <p>regardless of landscape elevation,</p>
            <p>you break some expectations and dial back others,</p>
            <p>sometimes you keep your head high and sometimes you don't.</p>
            <p>
                surreptitiously staring into the eyes of whatever beast is
                nearby,
            </p>
            <p>pupils so black they ignore the rest of the eye color,</p>
            <p>what else is there to do but keep going?</p>
        </div>
    );
};
